import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import AppConfigService from '../../services/AppConfig';
import {
  FormInput,
  FormInputLabel,
  FormOption,
  ValidationError,
} from '../../styles/FormStyledComponents';
import {
  EuroIcon,
  MainButton,
  MainButtonSection,
  Title,
} from '../../styles/GlobalStyledComponents';
import EuroImg from '../../assets/images/euro-icon.svg';
import { useCustomer } from './../../contexts/CustomerContext/customer-context.hook';
import { useCreditProposalResult } from './../../contexts/CreditProposalResultContext/creditProposalResult-hook';
import CreditProposalService from './../../services/CreditProposal/index';
import {
  AddressDetailSection,
  AddressSection,
  FormAddressRow,
  FormData,
  FormFloatingRow,
  FormInputData,
  FormInputLabelData,
  FormInputLabelNumber,
  FormInputNumber,
  FormNumber,
  FormPart,
  FormPostalCode,
  FormSelect,
  HandAddressButton,
  HandAddressSection,
  HousewifeInfo,
  IconImg,
  LaborDataSection,
  StyledForm,
} from './StyledComponents';
import { useNavigate } from 'react-router-dom';
import { ROUTES_PATH, VALIDATOR_PATTERN } from '../../constants';
import { DecisionStatus } from '../../interfaces/DecisionEngine';
import { PostalAddress } from '../../interfaces/PostalAddress';
import {
  validateAddress,
  validateAddressDetailNumber,
  validateAddressNumber,
  validateAuxAddress,
  validateContractType,
  validateMonthlyIncome,
  validatePostalCode,
  validateSimpleAddress,
} from './../../utils/validators';
import { identifyAddressTypes } from '../../utils/addressHelper';
import { FormFloating } from './../../styles/FormStyledComponents';
import { colors } from '../../styles/Colors';
import { KeyModel, Keys } from '../../services/AppConfig/types';
import { Customer } from '../../interfaces/Customer';
import { useCustomerClassification } from '../../contexts/CustomerClassificationContext';
import {
  CreditProposalFlowStep,
  CreditProposalResult,
} from '../../interfaces/CreditProposalResult';
import {
  blockCharacters,
  capitalizeFirstLetter,
  checkPostalCode,
  getCity,
} from '../../utils/formInputHelper';
import { City, LaborDataDetailForm } from '../../interfaces/AddressForm';
import JostickIcon from '../../assets/icons/jostick.svg';
import InsightService from '../../services/Insight';
import AnalyticsService from '../../services/Analytics';
import { DenialStep } from '../../interfaces/Analytics';
import AnalyticsHelper from '../../utils/analyticsHelper';
import dayjs from 'dayjs';
import {
  PepperPlacesAutocomplete,
} from '@pepper/pepper-styles-react';
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";


interface LaborDataProps {
  loadingEvent: (data: boolean) => void;
}
interface DataAux {
  auxiliaryData: string;
  numberData: string;
  postalCode: string;
}

export const LaborData: React.FC<LaborDataProps> = ({ loadingEvent }) => {
  let navigate = useNavigate();

  const { customer, onChangeCustomer, createCustomer } = useCustomer();
  const { createCreditProposalResult, creditProposalResult } =
    useCreditProposalResult();
  const { customerClassification } = useCustomerClassification();

  const [contractTypes, setContractTypes] = useState<Keys | null>(null);
  const [selectedJob, setSelectedJob] = useState<string>();
  const [income, setIncome] = useState<string>('');
  const [activeField, setActiveField] = useState<string | null>(null);
  const [addressValue, setAddressValue] = useState<any>(null);
  const [address, setAddress] = useState<PostalAddress | null>(null);
  const [addressError, setAddressError] = useState<string | undefined>(
    undefined,
  );
  const [errorsCont, setErrorsCont] = useState<number>(0);
  const [addressAuxData, setAddressAuxData] = useState<DataAux>();
  const [showAddressNumber, setShowAddressNumber] = useState(false);
  const [showPostalCode, setShowPostalCode] = useState(false);
  const [postalCodeError, setPostalCodeError] = useState(false);
  const postalCodeNotFound = 'No se encuentran ciudades con ese código postal';

  const [addressAuxError, setAddressAuxError] = useState(false);
  const [showAddressDetailSection, setShowAddressDetailSection] =
    useState(false);
  const [validIncome, setValidIncome] = useState(false);

  const [flowSus, setFlowSus] = useState<boolean>(false);
  const [handButton, setHandButton] = useState<boolean>(false);

  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    refreshSessionToken,
  } = usePlacesService({
    apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
  });

  useEffect(() => {
    getResults(placePredictions);
  }, [placePredictions]);

  const initialValues: LaborDataDetailForm = {
    address: '',
    addressDetailNumber: '',
    postalCode2: '',
    city: '',
    province: '',
    roadType: '',
    addressAux: '',
    contractType: '',
    monthlyIncome: '',
  };

  const startTime = dayjs();

  const [cities, setCities] = useState<City[]>([]);
  const [roadTypes, setRoadTypes] = useState<KeyModel[] | null>(null);
  const [initialVal, setInitialVal] =
    useState<LaborDataDetailForm>(initialValues);

  const handleAuxiliaryDataChange = async (data: DataAux) => {
    let chars = RegExp(/[<>&/]/g);
    if (data.auxiliaryData.length > 20 || chars.test(data.auxiliaryData)) {
      setAddressAuxError(true);
    } else if (data.auxiliaryData) {
      setAddressAuxError(false);
    } else {
      setAddressAuxError(false);
    }
    setAddressAuxData(data);
    validateAuxAddress(data);
    const newAddress = Object.create(address);
    newAddress.aux = data.auxiliaryData;

    if (data.postalCode)
      newAddress.postal_code = address?.postal_code || data.postalCode;
    onChangeCustomer('address', newAddress);
  };

  const newAddressObj = () => {
    return {
      road_type: '',
      address: '',
      number: '',
      aux: '',
      province: '',
      postal_code: '',
      city: '',
    };
  };

  const getDecisionData = async (
    creditProposalData: CreditProposalResult,
    counter: number,
  ) => {
    counter++;
    try {
      const decisionResp = await CreditProposalService.getDecision(
        creditProposalData.credit_proposal_id,
      );
      if (decisionResp) {
        switch (decisionResp.decision) {
          case DecisionStatus.APPROVED:
            //navigate(ROUTES_PATH.COUNTER_OFFER);
            if (customerClassification?.require_enrichment_personal_finances) {
              createCreditProposalResult({
                ...creditProposalData,
                flow_step: CreditProposalFlowStep.PERSONAL_FINANCES,
              } as CreditProposalResult);
            } else if (creditProposalData?.product === 'PLS') {
              createCreditProposalResult({
                ...creditProposalData,
                flow_step: CreditProposalFlowStep.BANK_READER,
              } as CreditProposalResult);
            } else if (
              customerClassification?.require_documentation &&
              !creditProposalData.ocr_id
            ) {
              createCreditProposalResult({
                ...creditProposalData,
                flow_step: CreditProposalFlowStep.OCR,
              } as CreditProposalResult);
            } else {
              createCreditProposalResult({
                ...creditProposalData,
                flow_step: CreditProposalFlowStep.PAYMENT,
              } as CreditProposalResult);
            }
            navigate(ROUTES_PATH.OPERATION_SHIPPING);
            break;
          case DecisionStatus.ALTERNATIVE_OFFER:
          case DecisionStatus.COUNTER_OFFER: // Contraoferta
            if (
              decisionResp.counter_offers &&
              decisionResp.counter_offers.length > 0
            ) {
              createCreditProposalResult({
                ...creditProposalData,
                counter_offers: decisionResp.counter_offers,
                flow_step: CreditProposalFlowStep.COUNTER_OFFER,
              } as CreditProposalResult);
            }
            navigate(ROUTES_PATH.COUNTER_OFFER);
            break;
          case DecisionStatus.DENIED:
            AnalyticsService.sendLoanRefused({ denial_step: DenialStep.DEC });
            navigate(ROUTES_PATH.DENIAL);
            break;
          case DecisionStatus.MISSING_DATA:
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
            break;
          default:
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
            break;
        }
        loadingEvent(false);
        InsightService.logTrace('DECISION LaborData', [
          { decisionResp: decisionResp },
        ]);
      }
    } catch (error: any) {
      if (`${error}`.includes('409') && counter <= 11) {
        setTimeout(() => {
          getDecisionData(creditProposalData, counter);
        }, 3000);
      } else {
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
        loadingEvent(false);
      }
    }
  };
  const getGooglePlacesDetails = (placeId: string) => {
    const request = {
      placeId: placeId,
      fields: ['address_components'],
    };
    placesService?.getDetails(request, getAddressDetailed);
  };

  const getResults = (places: any) => {
    if (places.length > 0 && places[0].place_id
    ) {
      getGooglePlacesDetails(places[0].place_id);
      refreshSessionToken();
    }
  };
  //Utiliza el addressValue para realizar las búsquedas/peticiones, con o sin número, por defecto
  const findNewAddress = (googleAddress: any, number?: string) => {
    if (googleAddress) {
      setAddressError('');
      if (number) {
        setShowAddressNumber(true);
      }
      if (address && number) {
        googlePlaceCall(address, number);
      } else if (!addressError && !number) {
        googlePlaceCall(googleAddress);
      } else {
        googlePlaceCall(googleAddress, number);
      }
      if (flowSus || !number) {
        const place_id =
          googleAddress.results?.place_id || googleAddress.value?.place_id;
        if (place_id) {
          getGooglePlacesDetails(place_id);
        }
      }
    }
  };

  const googlePlaceCall = (address: any, number?: string) => {
    if (!Object.values(address).every(value => value === '')) {
      const addressLabel = labelFormatAddress(address, number);
      if (!addressLabel.label.includes('undefined')) {
        refreshSessionToken();
        getPlacePredictions({
          input: addressLabel.label,
        });
      }
    }
  };
  //Flujos: dirección introducida de forma manual o dirección de Google Places
  const handleContinue = async (data: LaborDataDetailForm) => {
    //Primero se guardan los datos laborales que son comúnes
    if (data.monthlyIncome && data.contractType) {
      setSelectedJob(data.contractType);
      setIncome(data.monthlyIncome);
    }

    let updatedAddress: PostalAddress = newAddressObj();

    //Elegimos un flujo u otro para el resto de datos de la dirección:
    if (showAddressDetailSection) {
      updatedAddress = handleAddressDetail(data);
      setAddress(updatedAddress);
    } else {
      if (
        ((!addressError && address) ||
          !customerClassification?.require_address_data) &&
        ((contractTypes && income) ||
          !customerClassification?.require_labor_data)
      ) {
        if (
          address &&
          !addressAuxError &&
          customerClassification?.require_address_data
        ) {
          if (!address.number && addressAuxData?.numberData) {
            findNewAddress(addressValue, addressAuxData.numberData);
          } else {
            updatedAddress = address;
          }
          if (
            addressAuxData &&
            (addressAuxData.auxiliaryData || addressAuxData?.postalCode)
          ) {
            updatedAddress = Object.assign(address, {
              aux: addressAuxData.auxiliaryData,
              postal_code: showPostalCode
                ? addressAuxData.postalCode
                : address.postal_code,
            });
          }
          if (updatedAddress && !updatedAddress.postal_code) {
            setPostalCodeError(true);
          }
          if (updatedAddress && !updatedAddress.city && !address.city) {
            setAddressError('Selecciona una dirección que contenga una ciudad');
            checkErrorsCont();
          } else if (address.city) {
            updatedAddress.city = address.city;
          }
          setAddress(updatedAddress);
        }
      }
    }
    const updatedCustomer = addDataToCustomer(updatedAddress);
    patchCreditProposalData(updatedCustomer);
  };

  const patchCreditProposalData = async (updatedCustomer: any) => {
    try {
      loadingEvent(true);
      const response = await CreditProposalService.update(
        updatedCustomer!,
        creditProposalResult?.credit_proposal_id!,
      );

      AnalyticsService.continueLData({
        cust_contract_type: response.customer?.job?.contract_type,
        cust_monthly_income: response.customer?.job?.monthly_income,
        cust_province: response.customer?.address?.postal_code.substring(0, 2),
        cust_postal_code: response.customer?.address?.postal_code,
        used_manual_input: showAddressDetailSection,
        time_elapsed: AnalyticsHelper.getTimeElapse({
          initTime: startTime,
          finishTime: dayjs(),
        }),
        step_number: 3,
      });

      createCreditProposalResult(response);
      response.customer && createCustomer(response.customer);
      InsightService.logTrace('PATCH CreditProposal', [
        { creditProposal: response },
      ]);
      getDecisionData(response, 0);
    } catch (error) {
      loadingEvent(false);
      if (
        error &&
        error.response?.data?.result?.errors.find(
          (er: any) => er.code === 'DRF0089',
        )
      ) {
        InsightService.logTrace('PATCH CreditProposal - Belender exception', [
          { creditProposalError: error },
        ]);
        navigate(ROUTES_PATH.PERSONAL_FINANCES_UNAVAILABLE, {
          state: { errorType: 'DRF0089' },
        });
      } else if (
        error &&
        error.response?.data?.result?.errors.find(
          (er: any) => er.code === 'DRF0092',
        )
      ) {
        InsightService.logTrace('PATCH CreditProposal - Belender exception', [
          { creditProposalError: error },
        ]);
        //2º caso de error de Belender (jubilados/pensionistas)
        navigate(ROUTES_PATH.PERSONAL_FINANCES_UNAVAILABLE, {
          state: { errorType: 'DRF0092' },
        });
      } else {
        InsightService.logTrace('PATCH CreditProposal - ERROR', [
          { creditProposalError: error },
        ]);
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    }
  };

  const splitStringByLength = (str: string, length: number): string[] => {
    const result = [];
    for (let i = 0; i < str.length; i += length) {
      result.push(str.substring(i, i + length));
    }
    return result;
  };

  const addDataToCustomer = (updatedAddress: PostalAddress) => {
    if (customer) {
      let laborDataObj = [];
      if (customerClassification?.require_labor_data) {
        laborDataObj.push({
          op: 'replace',
          path: 'customer/job',
          value: {
            contract_type: selectedJob,
            monthly_income: parseFloat(income),
          },
        });
      }
      if (customerClassification?.require_address_data) {
        if (updatedAddress && updatedAddress.address.length > 46) {
          const addressParts = splitStringByLength(updatedAddress.address, 46);
          updatedAddress.address = addressParts[0];
          updatedAddress.aux = updatedAddress.aux + addressParts[1];
          if (updatedAddress.aux.length > 20) {
            const auxParts = splitStringByLength(updatedAddress.aux, 20);
            updatedAddress.aux = auxParts[0];
          }
        } else if (address && address.address.length > 46) {
          const addressParts = splitStringByLength(address.address, 46);
          address.address = addressParts[0];
          address.aux = address.aux + addressParts[1];
          if (address.aux.length > 20) {
            const auxParts = splitStringByLength(address.aux, 20);
            address.aux = auxParts[0];
          }
        }
        laborDataObj.push({
          op: 'replace',
          path: 'customer/address',
          value: updatedAddress || address,
        });
      }
      return laborDataObj;
    }
  };

  const getJobOptions = async () => {
    const data = await AppConfigService.getContractTypes();
    setContractTypes(data[0]);
  };

  const updatePostalCode = async (postalCode: string) => {
    if (address && VALIDATOR_PATTERN.POSTAL_CODE.test(postalCode)) {
      const postalCodeOk = await checkPostalCode(postalCode);
      if (postalCodeOk) {
        let newAddress = Object.assign(address, {
          postal_code: postalCode,
        });
        setAddress(newAddress);
      }
    }
  };

  const labelFormatAddress = (address: any, number?: any) => {
    const addressNumber = number ? number : '';
    const addressLabel =
      address.road_type +
      ' ' +
      address.address +
      ', ' +
      (addressNumber.length > 0 ? addressNumber + ', ' : '') +
      +(address.postal_code
        ? address.postal_code
        : addressAuxData?.postalCode
          ? addressAuxData.postalCode
          : '') +
      ' ' +
      address.city +
      ' ' +
      (address.province ? address.province : ' ');

    const labelObj = {
      label: addressLabel,
    };
    return labelObj;
  };

  const handleFocus = (event: any) => {
    if (event.type === 'focus') {
      setActiveField(event.target.name);
    } else if (event.type === 'blur') {
      setActiveField(null);
    }
  };

  const getAddressDetailed = (place: any, status: any) => {
    let newAddress = identifyAddressTypes(place.address_components);
    const validatorError = validateAddress(newAddress);
    document.getElementById('labor-data-address-input')?.blur();
    if (!validatorError) {
      if (newAddress.number || showAddressNumber) {
        if (showAddressNumber && !newAddress.number) {
          setAddressError('El número introducido no existe en la calle');
          checkErrorsCont();
          setShowAddressNumber(true);
        } else {
          setAddressError('');
        }
        if (!newAddress.postal_code) {
          setShowPostalCode(true);
        } else {
          setShowPostalCode(false);
        }
      } else {
        setAddressError('');
      }
      if (!newAddress.number) {
        setShowAddressNumber(true);
      }
      if (customer?.address?.aux) newAddress.aux = customer?.address?.aux;
      onChangeCustomer('address', newAddress);
      setAddress(newAddress);
      if (creditProposalResult?.product === 'SUS' && newAddress) {
        setAddressValue(labelFormatAddress(newAddress, newAddress.number));
      }
    } else {
      setAddressError(validatorError);
      checkErrorsCont();
    }
  };

  const checkMonthlyIncome = (value: string) => {
    if (validateMonthlyIncome(value) || value === '0') {
      setValidIncome(false);
    } else {
      setValidIncome(true);
    }
    setIncome(value);
  };

  //Comprobamos los errores que se han producido al introducir la dirección de Google Places
  const checkErrorsCont = () => {
    if (errorsCont > 0) {
      setHandButton(true);
      AnalyticsService.manualInputAvailable();
    } else {
      setErrorsCont(errorsCont + 1);
    }
  };

  const getCustomerRequires = () => {
    if (
      customerClassification?.require_address_data &&
      customerClassification.require_labor_data &&
      showAddressDetailSection
    ) {
      return 'ADDRESS_DETAIL_AND_LABOR';
    } else if (
      customerClassification?.require_address_data &&
      customerClassification.require_labor_data
    ) {
      return 'ADDRESS_AND_LABOR';
    } else if (
      customerClassification?.require_address_data &&
      showAddressDetailSection &&
      !customerClassification.require_labor_data
    ) {
      return 'ADDRESS_DETAIL_ONLY';
    } else if (customerClassification?.require_address_data) {
      return 'ADDRESS_ONLY';
    } else if (customerClassification?.require_labor_data) {
      return 'LABOR_ONLY';
    }
    return 'NONE';
  };

  const buttonDisablingCheck = (values: any) => {
    switch (getCustomerRequires()) {
      case 'ADDRESS_AND_LABOR':
        if (
          address?.city &&
          address?.number &&
          address?.postal_code &&
          !addressError &&
          !postalCodeError &&
          !addressAuxError &&
          selectedJob &&
          income &&
          (validIncome || flowSus)
        ) {
          return false;
        }
        break;
      case 'ADDRESS_DETAIL_AND_LABOR':
        if (
          selectedJob &&
          income &&
          (validIncome || flowSus) &&
          values?.city &&
          values?.addressDetailNumber &&
          values?.postalCode2 &&
          values?.province &&
          values?.address
        ) {
          return false;
        }
        break;
      case 'ADDRESS_ONLY':
        if (
          address?.city &&
          address?.number &&
          address?.postal_code &&
          !addressError &&
          !postalCodeError &&
          !addressAuxError
        ) {
          return false;
        }
        break;
      case 'LABOR_ONLY':
        if (selectedJob && income && validIncome) {
          return false;
        }
        break;
      case 'ADDRESS_DETAIL_ONLY':
        if (
          values?.city &&
          values?.addressDetailNumber &&
          values?.postalCode2 &&
          values?.province &&
          values?.address
        ) {
          return false;
        }
        break;
      case 'NONE':
      default:
        break;
    }

    return true;
  };

  const AddressDetailFormData = () => {
    const data: LaborDataDetailForm = {
      address: address?.address || '',
      addressDetailNumber: address?.number || '',
      postalCode2: address?.postal_code || '',
      city: address?.city || '',
      province: address?.province || '',
      roadType:
        address?.road_type ||
        (roadTypes && roadTypes[0] ? roadTypes?.[0]?.description_code : '') ||
        '',
      addressAux: address?.aux || '',
      contractType:
        customer?.job?.contract_type ||
        creditProposalResult?.customer?.job?.contract_type ||
        '',
      monthlyIncome:
        customer?.job?.monthly_income?.toString() ||
        creditProposalResult?.customer?.job?.monthly_income?.toString() ||
        '',
    };
    return data;
  };

  const getUserCity = async (
    postalCode: string,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean,
    ) => void,
  ) => {
    if (
      postalCode.length === 5 &&
      VALIDATOR_PATTERN.POSTAL_CODE.test(postalCode)
    ) {
      try {
        setFieldValue('city', '');
        setFieldValue('province', '');
        const cities = await getCity(postalCode || '');
        if (cities.length > 0) {
          setCities(cities);
          const cityData = cities.find(
            (city) => city.postal_code === postalCode,
          );
          if (cityData) {
            setFieldValue('city', cityData.city);
            setFieldValue('province', cityData.province);
          }
        } else {
          setCities([]);
        }
      } catch (error) {
        console.error('Error al obtener la ciudad: ', error);
      }
    }
  };
  //Se recuperan y almacenan los tipos de vías
  const getRoadTypesList = async () => {
    const roadTypesArray = await AppConfigService.getRoadTypes();
    if (roadTypesArray.length > 0 && roadTypesArray[0].keys) {
      setRoadTypes(roadTypesArray[0].keys);
    }
  };

  const handleAddressDetail = (data: LaborDataDetailForm) => {
    let newAddress = newAddressObj();
    if (data) {
      if (data.roadType === '') {
        data.roadType = roadTypes?.[0]?.code || '';
      }
      if (data.postalCode2.length < 5) {
        data.postalCode2 = `0${data.postalCode2}`;
      }
      newAddress = {
        address: data.address ? capitalizeFirstLetter(data.address) : '',
        number: data.addressDetailNumber,
        postal_code: data.postalCode2,
        city: data.city,
        province: data.province,
        road_type: data.roadType,
        aux: data.addressAux || '',
      };
    }
    return newAddress;
  };



  useEffect(() => {
    if (addressValue) {
      findNewAddress(addressValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressValue]);
  useEffect(() => {
    if (income && selectedJob) {
      const job = {
        monthly_income: income,
        job_type: '',
        contract_type: selectedJob,
      };
      onChangeCustomer('job', job);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [income, selectedJob]);

  useEffect(() => {
    getJobOptions();
    let customerData: Customer | undefined;
    if (customer && customer.address) {
      customerData = customer;
    } else if (creditProposalResult && creditProposalResult.customer) {
      customerData = creditProposalResult.customer;
    }

    if (customerData?.job) {
      setSelectedJob(customerData?.job?.contract_type);
      setIncome(customerData?.job?.monthly_income);
    }

    sessionStorage.getItem('Flow-SUS') === 'true'
      ? setFlowSus(true)
      : setFlowSus(false);

    loadingEvent(false);

    getRoadTypesList();

    const addressData = AddressDetailFormData();

    if (address && addressData) {
      setInitialVal(addressData);
    } else {
      setInitialVal({
        ...initialValues,
        roadType: roadTypes?.[0]?.description_code || '',
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <AddressSection
        id="labor-data-address-section"
        $isHidden={
          customerClassification?.require_address_data &&
            !showAddressDetailSection
            ? ''
            : 'true'
        }
      >
        <Title id="labor-data-address-title">Dirección</Title>
        <FormFloating>
          <PepperPlacesAutocomplete
            disableCapitalize
            onSelect={(PostalAddress: PostalAddress) => {
              setAddressValue(PostalAddress);
            }}
            onZeroResults={() => { }}
            defaultValue=""
            nativeLabel="inputLabel"
            nativeInput="addressInput"
            showBorder
            apiKey={import.meta.env.VITE_GOOGLE_API_KEY}
            label="Dirección (Calle Nº, ciudad)"
          />
          {addressError && <ValidationError>{addressError}</ValidationError>}
        </FormFloating>
        {address && (
          <Formik
            onSubmit={handleAuxiliaryDataChange}
            initialValues={{
              auxiliaryData:
                customer?.address?.aux ||
                creditProposalResult?.customer?.address?.aux ||
                '',
              numberData:
                // customer?.address?.number ||
                creditProposalResult?.customer?.address?.number || '',
              postalCode:
                // customer?.address?.postal_code ||
                creditProposalResult?.customer?.address?.postal_code || '',
            }}
          >
            {({
              errors,
              values,
              submitForm,
              handleBlur,
              handleChange,
              validateForm,
              touched,
            }) => (
              <Form onChange={submitForm}>
                <FormFloating>
                  <FormPart>
                    {showAddressNumber && (
                      <FormNumber $customWidth={showPostalCode ? '20%' : '25%'}>
                        <FormInputNumber
                          id="labor-data-number"
                          type="text"
                          pattern="[0-9]*"
                          inputMode="numeric"
                          autoComplete="off"
                          name="numberData"
                          validate={validateAddressNumber}
                          onFocus={(e: any) => {
                            handleFocus(e);
                          }}
                          onChange={(e: any) => {
                            handleChange(e);
                          }}
                          onBlur={(e: any) => {
                            handleBlur(e);
                            findNewAddress(addressValue, values.numberData);
                          }}
                          error={
                            errors.numberData && touched.numberData
                              ? 'error'
                              : ''
                          }
                        />
                        <FormInputLabelNumber
                          $error={
                            errors.numberData && touched.numberData
                              ? 'error'
                              : ''
                          }
                          htmlFor="numberData"
                          $emptyvalue={
                            values.numberData || activeField === 'numberData'
                              ? ''
                              : 'true'
                          }
                        >
                          Nº
                        </FormInputLabelNumber>
                        {errors.numberData && touched.numberData && (
                          <ValidationError>{errors.numberData}</ValidationError>
                        )}
                      </FormNumber>
                    )}
                    {showPostalCode && (
                      <FormPostalCode
                        $customWidth={showAddressNumber ? '' : '30%'}
                      >
                        <FormInputData
                          id="postal-code-number"
                          type="text"
                          pattern="[0-9]*"
                          inputMode="numeric"
                          autoComplete="off"
                          name="postalCode"
                          validate={validatePostalCode}
                          $position={!address?.number ? 'center' : 'left'}
                          onFocus={(e: any) => {
                            handleFocus(e);
                            setPostalCodeError(false);
                          }}
                          onBlur={(e: any) => {
                            handleBlur(e);
                            updatePostalCode(values.postalCode);
                            if (
                              (values.postalCode &&
                                values.postalCode.length > 5) ||
                              !values.postalCode
                            ) {
                              setPostalCodeError(true);
                            }
                          }}
                          error={
                            errors.postalCode && touched.postalCode
                              ? 'error'
                              : ''
                          }
                        />
                        <FormInputLabelNumber
                          $error={
                            errors.postalCode && touched.postalCode
                              ? 'error'
                              : ''
                          }
                          htmlFor="postalCode"
                          $emptyvalue={
                            values.postalCode || activeField === 'postalCode'
                              ? ''
                              : 'true'
                          }
                        >
                          C.P.
                        </FormInputLabelNumber>
                        {errors.postalCode && touched.postalCode && (
                          <ValidationError>{errors.postalCode}</ValidationError>
                        )}
                      </FormPostalCode>
                    )}
                    <FormData
                      $customWidth={
                        showPostalCode
                          ? `${showAddressNumber ? '50%' : '70%'}`
                          : `${showAddressNumber ? '75%' : '100%'}`
                      }
                    >
                      <FormInputData
                        type="text"
                        autoComplete="off"
                        name="auxiliaryData"
                        $position={
                          showAddressNumber || showPostalCode
                            ? 'right'
                            : 'center'
                        }
                        validate={validateAuxAddress}
                        onKeyUp={() => {
                          validateForm().then(submitForm);
                        }}
                        error={errors.auxiliaryData}
                        onFocus={handleFocus}
                        onBlur={(e: any) => {
                          handleBlur(e);
                        }}
                      />
                      <FormInputLabelData
                        htmlFor="auxiliaryData"
                        $emptyvalue={
                          values.auxiliaryData ||
                            activeField === 'auxiliaryData'
                            ? ''
                            : 'true'
                        }
                        $error={
                          errors.auxiliaryData && touched.auxiliaryData
                            ? 'error'
                            : ''
                        }
                      >
                        Escalera, Portal, Piso…
                      </FormInputLabelData>
                      <ValidationError>{errors.auxiliaryData}</ValidationError>
                    </FormData>
                  </FormPart>
                </FormFloating>
              </Form>
            )}
          </Formik>
        )}
        {handButton && (
          <HandAddressSection id="labor-data-hand-button-section">
            <IconImg src={JostickIcon} />
            <HandAddressButton
              id="labor-data-hand-address-button"
              onClick={() => {
                setShowAddressDetailSection(true);
                setHandButton(false);
              }}
            >
              Introducir dirección manualmente
            </HandAddressButton>
          </HandAddressSection>
        )}
      </AddressSection>

      <Formik
        onSubmit={handleContinue}
        initialValues={initialVal}
        id="labor-data-address-detail-formik"
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => (
          <StyledForm
            style={{ display: 'contents' }}
            id="labor-data-address-detail-form"
            onChange={(e: any) => {
              if (e.target.name === 'contractType') {
                setSelectedJob(e.target.value);
              }
            }}
          >
            {showAddressDetailSection && (
              /*--- NUEVA SECCIÓN @---*/
              <AddressDetailSection id="labor-data-address-detail-section">
                <Title id="labor-data-address-title">Dirección</Title>
                <FormAddressRow id="labor-data-address-row">
                  <FormFloatingRow $customWidth="40%">
                    <FormSelect
                      id="labor-data-road-type-select"
                      component="select"
                      name="roadType"
                      key="roadType"
                      value={
                        values.roadType || roadTypes?.[0]?.description_code
                      }
                      onChange={(e: any) => {
                        handleChange(e);
                      }}
                    >
                      {roadTypes?.map((key: KeyModel) => {
                        return (
                          <FormOption key={key.code} value={key.code}>
                            {key.description_code}
                          </FormOption>
                        );
                      })}
                    </FormSelect>
                    <FormInputLabel
                      id="labor-data-roadtype-label"
                      htmlFor="roadType"
                      $error={''}
                    >
                      Tipo de vía
                    </FormInputLabel>
                  </FormFloatingRow>
                  <FormFloatingRow $customWidth="60%">
                    <FormInput
                      id="labor-data-address-input"
                      type="text"
                      autoComplete="off"
                      name="address"
                      validate={validateSimpleAddress}
                      onFocus={handleFocus}
                      onBlur={(e: any) => {
                        handleBlur(e);
                      }}
                      error={errors.address && touched.address ? 'error' : ''}
                    />
                    <FormInputLabel
                      id="labor-data-address-label"
                      $error={errors.address && touched.address ? 'error' : ''}
                      htmlFor="address"
                      $emptyvalue={
                        values.address || activeField === 'address'
                          ? ''
                          : 'true'
                      }
                    >
                      Dirección
                    </FormInputLabel>
                    {errors.address && touched.address && (
                      <ValidationError>{errors.address}</ValidationError>
                    )}
                  </FormFloatingRow>
                </FormAddressRow>
                <FormAddressRow id="labor-data-address-row-2">
                  <FormFloatingRow $customWidth="40%">
                    <FormInput
                      id="labor-data-address-number-input"
                      type="text"
                      autoComplete="off"
                      name="addressDetailNumber"
                      validate={validateAddressDetailNumber}
                      onFocus={handleFocus}
                      error={
                        errors.addressDetailNumber &&
                          touched.addressDetailNumber
                          ? 'error'
                          : ''
                      }
                    />
                    <FormInputLabel
                      id="labor-data-address-number-label"
                      $error={
                        errors.addressDetailNumber &&
                          touched.addressDetailNumber
                          ? 'error'
                          : ''
                      }
                      htmlFor="addressDetailNumber"
                      $emptyvalue={
                        values.addressDetailNumber ||
                          activeField === 'addressDetailNumber'
                          ? ''
                          : 'true'
                      }
                    >
                      Nº
                    </FormInputLabel>
                    {errors.addressDetailNumber &&
                      touched.addressDetailNumber && (
                        <ValidationError>
                          {errors.addressDetailNumber}
                        </ValidationError>
                      )}
                  </FormFloatingRow>
                  <FormFloatingRow $customWidth="60%">
                    <FormInput
                      id="labor-data-address-aux-input"
                      type="text"
                      autoComplete="off"
                      name="addressAux"
                      validate={validateAuxAddress}
                      onFocus={handleFocus}
                      error={
                        errors.addressAux && touched.addressAux ? 'error' : ''
                      }
                    />
                    <FormInputLabel
                      id="labor-data-address-aux-label"
                      htmlFor="addressAux"
                      $error={
                        errors.addressAux && touched.addressAux ? 'error' : ''
                      }
                      $emptyvalue={
                        values.addressAux || activeField === 'addressAux'
                          ? ''
                          : 'true'
                      }
                    >
                      Escalera, Portal, Piso…
                    </FormInputLabel>
                    {errors.addressAux && touched.addressAux && (
                      <ValidationError>{errors.addressAux}</ValidationError>
                    )}
                  </FormFloatingRow>
                </FormAddressRow>

                <FormFloating>
                  <FormInput
                    id="postal-code-number"
                    type="text"
                    pattern="[0-9]*"
                    inputMode="numeric"
                    autoComplete="off"
                    name="postalCode2"
                    validate={validatePostalCode}
                    onFocus={handleFocus}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    onKeyUp={(e: any) => {
                      getUserCity(e.target.value, setFieldValue);
                    }}
                    error={
                      (errors.postalCode2 || cities.length === 0) &&
                        touched.postalCode2
                        ? 'error'
                        : ''
                    }
                  />
                  <FormInputLabel
                    $error={
                      (errors.postalCode2 || cities.length === 0) &&
                        touched.postalCode2
                        ? 'error'
                        : ''
                    }
                    htmlFor="postalCode2"
                    $emptyvalue={
                      values.postalCode2 || activeField === 'postalCode2'
                        ? ''
                        : 'true'
                    }
                  >
                    C.P.
                  </FormInputLabel>
                  {((errors.postalCode2 && touched.postalCode2) ||
                    (touched.postalCode2 && cities.length === 0)) && (
                      <ValidationError>
                        {errors.postalCode2 || postalCodeNotFound}
                      </ValidationError>
                    )}
                </FormFloating>
                <FormFloating>
                  <FormInput
                    id="labor-data-city-select"
                    component="select"
                    name="city"
                    key="city"
                    onBlur={(e: any) => {
                      values.city = e.target.value;
                    }}
                  >
                    {cities?.map((city: City) => {
                      return (
                        <FormOption
                          key={`${city.city}-${city.province}`}
                          value={city.city}
                        >
                          {city.city}
                        </FormOption>
                      );
                    })}
                  </FormInput>
                  <FormInputLabel id="labor-data-city-label" htmlFor="city">
                    Población
                  </FormInputLabel>
                </FormFloating>
                <FormFloating>
                  <FormInput
                    id="labor-data-province-input"
                    type="text"
                    autoComplete="off"
                    name="province"
                    isDisabled={true}
                    readOnly={true}
                    value={
                      cities.length > 0 && cities[0].province !== 'FALSE'
                        ? cities[0].province
                        : ''
                    }
                  />
                  <FormInputLabel
                    id="labor-data-province-label"
                    htmlFor="province"
                    $error={''}
                  >
                    Provincia
                  </FormInputLabel>
                </FormFloating>
              </AddressDetailSection>
            )}
            {customerClassification?.require_labor_data && (
              <LaborDataSection
                $isHidden={
                  customerClassification?.require_labor_data ? '' : 'true'
                }
              >
                <Title id="labor-data-job-title">Datos laborales</Title>
                <FormFloating>
                  <FormInput
                    id="labor-data-contract-input"
                    component="select"
                    type="select"
                    name="contractType"
                    validate={validateContractType}
                    error={
                      errors.contractType && touched.contractType ? 'error' : ''
                    }
                    position={values.contractType ? 'upper' : 'only'}
                  >
                    <FormOption
                      key="null"
                      value="null"
                      disabled={values.contractType ? true : false}
                    >
                      Seleccionar
                    </FormOption>
                    {contractTypes &&
                      contractTypes.keys.map((job: any) => {
                        return (
                          <FormOption key={job.code} value={job.code}>
                            {job.description_code}
                          </FormOption>
                        );
                      })}
                  </FormInput>
                  <FormInputLabel>Situación laboral</FormInputLabel>
                  {errors.contractType && touched.contractType && (
                    <ValidationError>{errors.contractType}</ValidationError>
                  )}
                </FormFloating>
                {values.contractType && (
                  <FormFloating>
                    <FormInput
                      id="labor-data-income-input"
                      autoComplete="off"
                      type="number"
                      inputMode="numeric"
                      name="monthlyIncome"
                      min="1"
                      step="any"
                      validate={validateMonthlyIncome}
                      onFocus={handleFocus}
                      onBlur={(e: any) => {
                        handleBlur(e);
                      }}
                      onKeyUp={() => {
                        checkMonthlyIncome(values.monthlyIncome);
                      }}
                      onKeyDown={blockCharacters}
                      error={
                        errors.monthlyIncome && touched.monthlyIncome
                          ? 'error'
                          : ''
                      }
                    />
                    {touched.monthlyIncome}
                    <FormInputLabel
                      $emptyvalue={
                        values.monthlyIncome ||
                          activeField === 'monthlyIncome' ||
                          parseFloat(income) === 0
                          ? ''
                          : 'true'
                      }
                      $error={
                        errors.monthlyIncome && touched.monthlyIncome
                          ? 'error'
                          : ''
                      }
                    >
                      Ingresos netos mensuales
                    </FormInputLabel>
                    <EuroIcon src={EuroImg}></EuroIcon>
                    {errors.monthlyIncome && touched.monthlyIncome && (
                      <ValidationError>{errors.monthlyIncome}</ValidationError>
                    )}
                  </FormFloating>
                )}
                {values.contractType === 'C' && (
                  <HousewifeInfo $fontSize={12} $color={colors.gray6}>
                    *Añade la fuente de ingresos de la unidad familiar
                  </HousewifeInfo>
                )}
              </LaborDataSection>
            )}
            <MainButtonSection>
              <MainButton
                type="submit"
                id="labor-data-continue-btn"
                disabled={buttonDisablingCheck(values)}
              >
                Continuar
              </MainButton>
            </MainButtonSection>
          </StyledForm>
        )}
      </Formik>
    </>
  );
};
